import { useEditorStore } from '../../stores/editorStore';

export default function ModeSelector() {
  const { mode, entityPaletteScope, setMode, setEntityPaletteScope } = useEditorStore();

  return (
    <div className="toolbar-group">
      <button
        className={`toolbar-button ${mode === 'layouts' ? 'active' : ''}`}
        onClick={() => setMode('layouts')}
        title="Edit decorations and background objects"
      >
        Decorations
      </button>
      <button
        className={`toolbar-button ${mode === 'entities' && entityPaletteScope === 'level' ? 'active' : ''}`}
        onClick={() => {
          setEntityPaletteScope('level');
        }}
        title="Edit entities from the current level"
      >
        Entities
      </button>
      <button
        className={`toolbar-button ${mode === 'entities' && entityPaletteScope === 'all' ? 'active' : ''}`}
        onClick={() => {
          setEntityPaletteScope('all');
        }}
        title="Show entities from all levels together"
      >
        All Entities
      </button>
    </div>
  );
}
